import { Button, Flex, Input, Select, Spinner, Table, TableCaption, Tbody, Td, Text, Th, Thead, Tr, useToast } from '@chakra-ui/react'
import Axios from 'axios'
import { useEffect } from 'react'
import { useState } from 'react'
import JSZip from 'jszip'
import Header from '../../components/Header/index'
import { Layout } from './Layout'
import { HeadingPages } from '../../components/HeadingPages'
import { AiFillFilePdf } from 'react-icons/ai'
import { AiFillFileText } from 'react-icons/ai'
import { useForm } from 'react-hook-form'
import schema from './@schema/schema'
import { yupResolver } from '@hookform/resolvers/yup'
import { baseURL } from '../../services/api'

export function ExportacaoNotas() {
  const [nunota, setNunota] = useState([])
  const [enterPrise, setEnterprise] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingNota, setLoadingNota] = useState(false)
  const [onDownloadProgress, setOnDownloadProgress] = useState(0)
  const [individual, setIndividual] = useState(false)
  const [search, setSearch] = useState('')
  const toast = useToast()
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })

  async function getListEnterprise() {
    const response = await baseURL.get('/pedido/lista-empresas')

    console.log(response.data)
    setEnterprise(response.data)
  }

  //mes - empresa

  const empresa = watch('empresa')
  const data_inicial = watch('data_inicial')
  const data_final = watch('data_final')

  async function getNunota() {
    setLoadingNota(true)
    const response = await baseURL.get(`/pedido/lista-nunota-empresas-financeiro/${empresa}/${data_inicial}/${data_final}`)

    setNunota(response.data)

    setLoadingNota(false)
  }

  function downloadAllFilesAsZip() {
    const zip = new JSZip()
    const zipFilename = 'files_pdf.zip'
    const promises = []

    setLoading(true)

    nunotaReduce.forEach((id) => {
      const url = `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/download-nota/${id}`
      const promise = Axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      })
        .then((response) => {
          const filename = `pdf_${id}.pdf`
          zip.file(filename, response.data)
        })
        .catch((error) => {
          console.error(`Erro ao baixar arquivo ${id}:`, error)
        })
      promises.push(promise)
    })

    Promise.all(promises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        const downloadUrl = window.URL.createObjectURL(content)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', zipFilename)
        document.body.appendChild(link)
        link.click()
      })

      toast({
        title: 'Arquivo baixado com sucesso.',
        status: 'success',
        position: 'top-right',
        duration: 9000,
        isClosable: true,
      })

      setLoading(false)
    })
  }

  async function downloadAllFilesXmlAsZip() {
    const zip = new JSZip()
    const zipFilename = 'files_xml.zip'
    const promises = []

    setLoading(true)

    nunotaReduce.forEach((id) => {
      console.log('Baixando arquivo:', id)
      const url = `${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/download-xml/${id}`
      const promise = Axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
      })
        .then((response) => {
          const filename = `xml_${id}.xml`
          zip.file(filename, response.data)
        })
        .catch((error) => {
          console.error(`Erro ao baixar arquivo ${id}:`, error)
        })
      promises.push(promise)
    })

    Promise.all(promises).then(() => {
      zip.generateAsync({ type: 'blob' }).then((content) => {
        const downloadUrl = window.URL.createObjectURL(content)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', zipFilename)
        document.body.appendChild(link)
        link.click()
      })

      toast({
        title: 'Arquivo baixado com sucesso.',
        status: 'success',
        position: 'top-right',
        duration: 9000,
        isClosable: true,
      })

      setLoading(false)
    })
  }

  const nunotaReduce = nunota.reduce((acc, item) => {
    const { NUNOTA } = item

    acc.push(NUNOTA)

    return acc
  }, [])

  console.log(nunotaReduce)

  useEffect(() => {
    if (empresa && data_inicial && data_final) {
      getNunota()
    }
  }, [empresa, data_inicial, data_final])

  useEffect(() => {
    getListEnterprise()
  }, [])

  const listSearch = nunota.filter((item) => {
    //se tiver algo escrito no input de busca se não retorna tudo
    if (search) {
      return item.NUNOTA.includes(search)
    }
    return item
  })

  useEffect(() => {
    const interval = setInterval(() => {
      if (loading) {
        setOnDownloadProgress((prev) => prev + 5)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [onDownloadProgress, loading])

  return (
    <>
      <HeadingPages name="Download PDF/XML" />
      <Layout>
        <Flex gap={2} mt="2rem">
          <Flex flexDir="column">
            <Select placeholder="Selecione a empresa" {...register('empresa')}>
              {enterPrise.map((item, index) => (
                <option key={index} value={item.codigo_empresa}>
                  {item.nome_empresa}
                </option>
              ))}
            </Select>
            {errors?.empresa && (
              <Text color="red" fontSize=".9rem">
                {errors.empresa.message}
              </Text>
            )}
          </Flex>
          <Flex flexDir="column">
            <Input type="date" {...register('data_inicial')} />
            {errors?.data_inicial && (
              <Text color="red" fontSize=".9rem">
                {errors.data_inicial.message}
              </Text>
            )}
          </Flex>

          <Flex flexDir="column">
            <Input type="date" {...register('data_final')} />
            {errors?.data_final && (
              <Text color="red" fontSize=".9rem">
                {errors.data_final.message}
              </Text>
            )}
          </Flex>
        </Flex>
        {nunota.length > 0 && (
          <Text fontSize="1.5rem" fontWeight="bold">
            {nunota.length} Arquivos encontrados
          </Text>
        )}
        <Flex gap={2}>
          <Button
            onClick={downloadAllFilesAsZip}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
            bgColor="#ff0000"
            color="white"
            border="1px solid transparent"
            _hover={{
              bgColor: 'white',
              color: '#ff0000',
              border: '1px solid #ff0000',
            }}
            isLoading={loadingNota}
          >
            <AiFillFilePdf size={20} />
            Baixar todos os PDF
          </Button>
          <Button
            onClick={downloadAllFilesXmlAsZip}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={1}
            bgColor="#008500"
            color="white"
            border="1px solid transparent"
            _hover={{
              bgColor: 'white',
              color: '#008500',
              border: '1px solid #008500',
            }}
            isLoading={loadingNota}
          >
            <AiFillFileText size={20} />
            Baixar todos os XML
          </Button>
        </Flex>
        {loading && (
          <Flex
            alignItems="center"
            justifyContent="center"
            w="100%"
            h="100%"
            position="absolute"
            top="0"
            left="0"
            bgColor="rgba(0,0,0,0.5)"
            flexDirection="column"
            gap={2}
            zIndex="999"
          >
            <Spinner size="xl" color="white" />

            <Text ml="1rem" color="white">
              {onDownloadProgress}%
            </Text>
          </Flex>
        )}

        <Button onClick={() => setIndividual(!individual)}>Ver arquivos individualmente</Button>
        {nunota.length > 0 && !!individual && (
          <>
            <Input
              type="text"
              placeholder="Pesquisar por numero nota"
              onChange={(e) => setSearch(e.target.value)}
              alignSelf="flex-start"
              maxWidth="300px"
            />
            <Table mt="2rem" variant="striped">
              <TableCaption placement="top">
                <Flex justifyContent={'space-between'}>
                  <Text>Opcional: baixar arquivos individualmente</Text>
                  <Text>Quantidade de arquivos: {listSearch.length}</Text>
                </Flex>
              </TableCaption>
              <Thead bgColor="#c1e6ff">
                <Tr>
                  <Th>Número da nota</Th>
                  <Th>PDF</Th>
                  <Th>XML</Th>
                </Tr>
              </Thead>
              <Tbody>
                {listSearch.map((item, index) => (
                  <Tr key={index}>
                    <Td>{item.NUNOTA}</Td>
                    <Td>
                      <Button
                        as="a"
                        href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/download-nota/${item.NUNOTA}`}
                        display="flex"
                        alignItems="center"
                        maxWidth="fit-content"
                        justifyContent="center"
                        gap={1}
                        bgColor="#ff0000"
                        color="white"
                        border="1px solid transparent"
                        fontSize=".7rem"
                        _hover={{
                          bgColor: 'white',
                          color: '#ff0000',
                          border: '1px solid #ff0000',
                        }}
                      >
                        <AiFillFilePdf size={20} />
                        PDF
                      </Button>
                    </Td>
                    <Td>
                      <Button
                        as="a"
                        href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/download-xml/${item.NUNOTA}`}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        maxWidth="fit-content"
                        gap={1}
                        bgColor="#008500"
                        color="white"
                        border="1px solid transparent"
                        fontSize=".7rem"
                        _hover={{
                          bgColor: 'white',
                          color: '#008500',
                          border: '1px solid #008500',
                        }}
                      >
                        <AiFillFileText size={20} />
                        XML
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </>
        )}
      </Layout>
    </>
  )
}
